import { useMainLayoutContext } from "@/context/MainLayoutContext";
import { useLayout } from "@/hooks/useLayout";
import CustomCombobox from "./CustomCombobox";

interface Props {
  selectClassName?: string;
  edit?: boolean;
  subjectValue: string;
  classValue: string;
  customName?: string;
  subjectOnChange: (value: string) => void;
  classOnChange: (value: string) => void;
}

const SubjectAndClassSelect = (props: Props) => {
  const {
    selectClassName,
    edit,
    subjectValue,
    classValue,
    subjectOnChange,
    classOnChange,
    customName,
  } = props;
  const layout = useLayout();
  const { subjects, allocations, classes } = useMainLayoutContext();

  if (layout === "admin") {
    return (
      <>
        <CustomCombobox
          options={
            subjects?.map(({ id, title }) => ({
              label: title,
              value: id,
            })) ?? []
          }
          value={subjectValue}
          key={subjectValue}
          onChange={(val) => subjectOnChange(val)}
          placeholder="Subject"
          containerClassName={selectClassName}
          {...(!!edit && { name: "subject", label: "Subject" })}
        />
        <CustomCombobox
          options={
            classes?.map(({ id, class: className }) => ({
              value: id,
              label: className,
            })) ?? []
          }
          value={classValue}
          key={classValue}
          onChange={(val) => classOnChange(val)}
          placeholder="Class"
          containerClassName={selectClassName}
          {...(!!edit && { name: "class", label: "Class" })}
        />
      </>
    );
  }

  return (
    <>
      <CustomCombobox
        options={
          allocations?.map(({ class_id, subject_id, class: className, subject }) => ({
            value: subject_id.concat("-", class_id),
            label: subject.concat(" ", className),
          })) ?? []
        }
        value={
          !!subjectValue && !!classValue
            ? subjectValue.concat("-", classValue)
            : ""
        }
        key={
          !!subjectValue && !!classValue
            ? subjectValue.concat("-", classValue)
            : ""
        }
        onChange={(val) => {
          const [subjectVal, classVal] = val.split("-");
          subjectOnChange(subjectVal);
          classOnChange(classVal);
        }}
        placeholder="Allocation"
        className={selectClassName}
        {...(!!edit && { name: customName ?? "subject", label: "Allocation" })}
      />
    </>
  );
};

export default SubjectAndClassSelect;
